import { BgColorOptions, ColorOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { CUSTOMER_GROUPS, customerGroupVisibilityCmsField } from '../../customer/groups/customer-groups';
import { ICONS_OPTIONS } from '../../styles/cms.config';
import { NOffCanvas } from './off-canvas.interface';

export const CMS_EDITS_SECTION = [
    <NICmsContentField.IField>{
        key: 'newEditsSectionTurnOn',
        type: NICmsContentField.EFieldType.toggle,
        title: 'New Edits Section for B variant of the experiment',
        default: false
    },
    <NICmsContentField.IField>{
        key: 'newEditsSectionTitle',
        type: NICmsContentField.EFieldType.text,
        title: 'New Edits Section Title',
        description: 'Title for the new edits section for B variant of the experiment',
        canShow: data => data.newEditsSectionTurnOn
    },
    <NICmsContentField.IRepeaterField>{
        type: NICmsContentField.EFieldType.repeater,
        key: 'newEditsSectionItems',
        title: 'New Edits Section Items',
        itemName: 'Item',
        itemNameField: 'text',
        fields: [
            <NICmsContentField.IField>{
                key: 'text',
                type: NICmsContentField.EFieldType.text,
                title: 'Item text',
                default: 'Some link',
                required: true
            },
            <NICmsContentField.IChoiceField>{
                type: NICmsContentField.EFieldType.choice,
                key: 'textColor',
                title: 'Text Color',
                options: ColorOptions,
                colorPreview: true,
                default: ''
            },
            <NICmsContentField.IField>{
                key: 'link',
                type: NICmsContentField.EFieldType.text,
                title: 'Link'
            }
        ],
        canShow: data => data.newEditsSectionTurnOn
    }
];

export const CMS_PROMO_BANNER_SECTION = [
    <NICmsContentField.IField>{
        key: 'bannersSectionTurnOn',
        type: NICmsContentField.EFieldType.toggle,
        title: 'Promo Banners Section for B variant of the experiment',
        default: false
    },
    <NICmsContentField.IRepeaterField>{
        type: NICmsContentField.EFieldType.repeater,
        key: 'bannerSectionItems',
        title: 'Promo Banner Section Items',
        itemName: 'Item',
        itemNameField: 'text',
        fields: [
            <NICmsContentField.IField>{
                type: NICmsContentField.EFieldType.image,
                key: 'image',
                title: 'Image'
            },
            <NICmsContentField.IField>{
                key: 'text',
                type: NICmsContentField.EFieldType.text,
                title: 'Item text',
                default: 'Some link',
                required: true
            },
            <NICmsContentField.IChoiceField>{
                type: NICmsContentField.EFieldType.choice,
                key: 'textColor',
                title: 'Text Color',
                options: ColorOptions,
                colorPreview: true,
                default: ''
            },
            <NICmsContentField.IField>{
                key: 'textCTA',
                type: NICmsContentField.EFieldType.text,
                title: 'CTA text',
                required: true
            },
            <NICmsContentField.IField>{
                key: 'link',
                type: NICmsContentField.EFieldType.text,
                title: 'Link'
            }
        ],
        canShow: data => data.bannersSectionTurnOn
    }
];

export const OFF_CANVAS_CONFIG: Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'> = {
    id: NOffCanvas.ID,
    onDemandOnly: true,
    block: {
        url: NOffCanvas.ID,
        scope: 'website',
        autoload: 'bootstrap'
    },
    name: 'Off Canvas Menu',
    description: 'Off canvas menu component',
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'menu',
            title: 'Menu Items',
            itemName: 'Item',
            itemNameField: 'text',
            defaultSize: 3,
            complex: true,
            fields: [
                <NICmsContentField.IField>{
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Item text',
                    default: 'Some link',
                    required: true
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'text_color',
                    title: 'Text Color',
                    options: ColorOptions,
                    colorPreview: true,
                    default: ''
                },
                <NICmsContentField.IField>{
                    key: 'isTextBold',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Is Text Bold',
                    description: 'Make text bold in B variant of the experiment',
                    default: false
                },
                <NICmsContentField.IField>{
                    key: 'copy_text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Copy Text'
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'copy_text_color',
                    title: 'Copy Text Color',
                    options: ColorOptions,
                    colorPreview: true,
                    default: ''
                },
                <NICmsContentField.IField>{
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                },
                <NICmsContentField.IField>{
                    key: 'is_separator',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Is separator',
                    default: false
                },
                <NICmsContentField.IField>{
                    key: 'display_arrow',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Display arrow',
                    default: false
                },
                <NICmsContentField.IField>{
                    key: 'hideNotifications',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Hide notifications',
                    default: false
                },
                <NICmsContentField.IField>{
                    key: 'second_level_turn_on',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Level 2 turn on',
                    default: false
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'second_level_background_color',
                    title: 'Level 2 background color',
                    options: BgColorOptions,
                    colorPreview: true
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'second_level_items',
                    title: 'Level 2 Items',
                    itemName: 'Item',
                    itemNameField: 'text',
                    complex: true,
                    fields: [
                        <NICmsContentField.IField>{
                            key: 'text',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Item text',
                            default: 'Some link'
                        },
                        <NICmsContentField.IField>{
                            key: 'isTextBold',
                            type: NICmsContentField.EFieldType.toggle,
                            title: 'Is Text Bold',
                            description: 'Make text bold in B variant of the experiment',
                            default: false
                        },
                        <NICmsContentField.IChoiceField>{
                            type: NICmsContentField.EFieldType.choice,
                            key: 'text_color',
                            title: 'Text Color',
                            options: ColorOptions,
                            colorPreview: true,
                            default: ''
                        },
                        <NICmsContentField.IField>{
                            key: 'copy_text',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Copy Text'
                        },
                        <NICmsContentField.IChoiceField>{
                            type: NICmsContentField.EFieldType.choice,
                            key: 'copy_text_color',
                            title: 'Copy Text Color',
                            options: ColorOptions,
                            colorPreview: true,
                            default: ''
                        },
                        <NICmsContentField.IField>{
                            key: 'link',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Link'
                        },
                        <NICmsContentField.IField>{
                            key: 'is_separator',
                            type: NICmsContentField.EFieldType.toggle,
                            title: 'Is separator',
                            default: false
                        },
                        <NICmsContentField.IField>{
                            key: 'display_arrow',
                            type: NICmsContentField.EFieldType.toggle,
                            title: 'Display arrow',
                            default: false
                        },
                        <NICmsContentField.IField>{
                            key: 'hideNotifications',
                            type: NICmsContentField.EFieldType.toggle,
                            title: 'Hide notifications',
                            default: false
                        },
                        <NICmsContentField.IField>{
                            key: 'third_level_turn_on',
                            type: NICmsContentField.EFieldType.toggle,
                            title: 'Level 3 turn on',
                            default: false
                        },
                        <NICmsContentField.IRepeaterField>{
                            type: NICmsContentField.EFieldType.repeater,
                            key: 'third_level_items',
                            title: 'Level 3 Items',
                            itemName: 'Item',
                            itemNameField: 'text',
                            complex: true,
                            fields: [
                                <NICmsContentField.IField>{
                                    key: 'text',
                                    type: NICmsContentField.EFieldType.text,
                                    title: 'Item text',
                                    default: 'Some link',
                                    required: true
                                },
                                <NICmsContentField.IField>{
                                    key: 'isTextBold',
                                    type: NICmsContentField.EFieldType.toggle,
                                    title: 'Is Text Bold',
                                    description: 'Make text bold in B variant of the experiment',
                                    default: false
                                },
                                <NICmsContentField.IChoiceField>{
                                    type: NICmsContentField.EFieldType.choice,
                                    key: 'text_color',
                                    title: 'Text Color',
                                    options: ColorOptions,
                                    colorPreview: true,
                                    default: ''
                                },
                                <NICmsContentField.IField>{
                                    key: 'copy_text',
                                    type: NICmsContentField.EFieldType.text,
                                    title: 'Copy Text'
                                },
                                <NICmsContentField.IChoiceField>{
                                    type: NICmsContentField.EFieldType.choice,
                                    key: 'copy_text_color',
                                    title: 'Copy Text Color',
                                    options: ColorOptions,
                                    colorPreview: true,
                                    default: ''
                                },
                                <NICmsContentField.IField>{
                                    key: 'link',
                                    type: NICmsContentField.EFieldType.text,
                                    title: 'Link'
                                },
                                <NICmsContentField.IField>{
                                    key: 'is_separator',
                                    type: NICmsContentField.EFieldType.toggle,
                                    title: 'Is separator',
                                    default: false
                                },
                                <NICmsContentField.IField>{
                                    key: 'display_arrow',
                                    type: NICmsContentField.EFieldType.toggle,
                                    title: 'Display arrow',
                                    default: false
                                },
                                <NICmsContentField.IField>{
                                    key: 'hideNotifications',
                                    type: NICmsContentField.EFieldType.toggle,
                                    title: 'Hide notifications',
                                    default: false
                                },
                                <NICmsContentField.IField>{
                                    key: 'fourth_level_turn_on',
                                    type: NICmsContentField.EFieldType.toggle,
                                    title: 'Level 4 turn on',
                                    default: false
                                },
                                <NICmsContentField.IRepeaterField>{
                                    type: NICmsContentField.EFieldType.repeater,
                                    key: 'fourth_level_items',
                                    title: 'Level 4 Items',
                                    itemName: 'Item',
                                    itemNameField: 'text',
                                    complex: true,
                                    fields: [
                                        <NICmsContentField.IField>{
                                            key: 'text',
                                            type: NICmsContentField.EFieldType.text,
                                            title: 'Item text',
                                            default: 'Some link',
                                            required: true
                                        },
                                        <NICmsContentField.IField>{
                                            key: 'isTextBold',
                                            type: NICmsContentField.EFieldType.toggle,
                                            title: 'Is Text Bold',
                                            description: 'Make text bold in B variant of the experiment',
                                            default: false
                                        },
                                        <NICmsContentField.IChoiceField>{
                                            type: NICmsContentField.EFieldType.choice,
                                            key: 'text_color',
                                            title: 'Text Color',
                                            options: ColorOptions,
                                            colorPreview: true,
                                            default: ''
                                        },
                                        <NICmsContentField.IField>{
                                            key: 'copy_text',
                                            type: NICmsContentField.EFieldType.text,
                                            title: 'Copy Text'
                                        },
                                        <NICmsContentField.IChoiceField>{
                                            type: NICmsContentField.EFieldType.choice,
                                            key: 'copy_text_color',
                                            title: 'Copy Text Color',
                                            options: ColorOptions,
                                            colorPreview: true,
                                            default: ''
                                        },
                                        <NICmsContentField.IField>{
                                            key: 'link',
                                            type: NICmsContentField.EFieldType.text,
                                            title: 'Link'
                                        },
                                        <NICmsContentField.IField>{
                                            key: 'is_separator',
                                            type: NICmsContentField.EFieldType.toggle,
                                            title: 'Is separator',
                                            default: false
                                        },
                                        customerGroupVisibilityCmsField(CUSTOMER_GROUPS)
                                    ],
                                    canShow: data => data.fourth_level_turn_on
                                },
                                customerGroupVisibilityCmsField(CUSTOMER_GROUPS)
                            ],
                            canShow: data => data.third_level_turn_on
                        },
                        <NICmsContentField.IField>{
                            key: 'quick_links_turn_on',
                            type: NICmsContentField.EFieldType.toggle,
                            title: 'Quick links',
                            default: false
                        },
                        <NICmsContentField.IField>{
                            key: 'quick_links_text',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Quick link text',
                            default: 'Edits',
                            canShow: data => data.quick_links_turn_on
                        },
                        <NICmsContentField.IRepeaterField>{
                            type: NICmsContentField.EFieldType.repeater,
                            key: 'quick_links_items',
                            title: 'Quick Links',
                            itemName: 'Item',
                            itemNameField: 'text',
                            fields: [
                                <NICmsContentField.IField>{
                                    type: NICmsContentField.EFieldType.image,
                                    key: 'image',
                                    title: 'Image'
                                },
                                <NICmsContentField.IField>{
                                    key: 'text',
                                    type: NICmsContentField.EFieldType.text,
                                    title: 'Item text',
                                    default: 'Some link',
                                    required: true
                                },
                                <NICmsContentField.IChoiceField>{
                                    type: NICmsContentField.EFieldType.choice,
                                    key: 'text_color',
                                    title: 'Text Color',
                                    options: ColorOptions,
                                    colorPreview: true,
                                    default: ''
                                },
                                <NICmsContentField.IField>{
                                    key: 'link',
                                    type: NICmsContentField.EFieldType.text,
                                    title: 'Link'
                                },
                                customerGroupVisibilityCmsField(CUSTOMER_GROUPS)
                            ],
                            canShow: data => data.quick_links_turn_on
                        },
                        ...CMS_EDITS_SECTION,
                        ...CMS_PROMO_BANNER_SECTION,
                        customerGroupVisibilityCmsField(CUSTOMER_GROUPS)
                    ],
                    canShow: data => data.second_level_turn_on
                },
                <NICmsContentField.IField>{
                    key: 'quick_links_turn_on',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Quick links',
                    default: false
                },
                <NICmsContentField.IField>{
                    key: 'quick_links_text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Quick link text',
                    default: 'Edits',
                    canShow: data => data.quick_links_turn_on
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'quick_links_items',
                    title: 'Quick Links',
                    itemName: 'Item',
                    itemNameField: 'text',
                    fields: [
                        <NICmsContentField.IField>{
                            type: NICmsContentField.EFieldType.image,
                            key: 'image',
                            title: 'Image'
                        },
                        <NICmsContentField.IField>{
                            key: 'text',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Item text',
                            default: 'Some link',
                            required: true
                        },
                        <NICmsContentField.IChoiceField>{
                            type: NICmsContentField.EFieldType.choice,
                            key: 'text_color',
                            title: 'Text Color',
                            options: ColorOptions,
                            colorPreview: true,
                            default: ''
                        },
                        <NICmsContentField.IField>{
                            key: 'link',
                            type: NICmsContentField.EFieldType.text,
                            title: 'Link'
                        },
                        customerGroupVisibilityCmsField(CUSTOMER_GROUPS)
                    ],
                    canShow: data => data.quick_links_turn_on
                },
                ...CMS_EDITS_SECTION,
                ...CMS_PROMO_BANNER_SECTION,
                customerGroupVisibilityCmsField(CUSTOMER_GROUPS)
            ]
        },
        <NICmsContentField.IField>{
            key: 'quick_links_turn_on',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Quick links',
            default: false
        },
        <NICmsContentField.IField>{
            key: 'quick_links_text',
            type: NICmsContentField.EFieldType.text,
            title: 'Quick link text',
            default: 'Edits',
            canShow: data => data.quick_links_turn_on
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'quick_links_items',
            title: 'Quick Links',
            itemName: 'Item',
            itemNameField: 'text',
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                },
                <NICmsContentField.IField>{
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Item text',
                    default: 'Some link',
                    required: true
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'text_color',
                    title: 'Text Color',
                    options: ColorOptions,
                    colorPreview: true,
                    default: ''
                },
                <NICmsContentField.IField>{
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link'
                },
                customerGroupVisibilityCmsField(CUSTOMER_GROUPS)
            ],
            canShow: data => data.quick_links_turn_on
        },
        ...CMS_EDITS_SECTION,
        ...CMS_PROMO_BANNER_SECTION,
        <NICmsContentField.IField>{
            key: 'footerItemsShow',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Footer Items',
            default: false
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'footerItems',
            title: 'Footer Items',
            itemName: 'item',
            fields: [
                <NICmsContentField.IChoiceField>{
                    key: 'type',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Type',
                    default: 'link',
                    options: [
                        {
                            key: 'link',
                            title: 'Link'
                        },
                        {
                            key: 'countrySelector',
                            title: 'Country Selector'
                        }
                    ]
                },
                <NICmsContentField.IField>{
                    key: 'ctaText',
                    type: NICmsContentField.EFieldType.text,
                    title: 'CTA Text',
                    default: '',
                    canShow: (data: NOffCanvas.IFooterItems) => data.type === 'link'
                },
                <NICmsContentField.IField>{
                    key: 'ctaLink',
                    type: NICmsContentField.EFieldType.text,
                    title: 'CTA Link',
                    default: '',
                    canShow: (data: NOffCanvas.IFooterItems) => data.type === 'link'
                },
                <NICmsContentField.IField>{
                    key: 'fontColor',
                    type: NICmsContentField.EFieldType.colorPicker,
                    colorPreview: true,
                    title: 'Font color',
                    canShow: (data: NOffCanvas.IFooterItems) => data.type === 'link'
                }
            ],
            canShow: data => data.footerItemsShow
        },
        <NICmsContentField.IField>{
            key: 'footerItemsShowBVariant',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Footer Items',
            default: false
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'footerItemsBVariant',
            title: 'Footer Items for B variant',
            itemName: 'item',
            fields: [
                <NICmsContentField.IChoiceField>{
                    key: 'icon',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Icon',
                    previewMode: 'icon',
                    options: ICONS_OPTIONS
                },
                <NICmsContentField.IField>{
                    key: 'ctaText',
                    type: NICmsContentField.EFieldType.text,
                    title: 'CTA Text',
                    default: ''
                },
                <NICmsContentField.IField>{
                    key: 'ctaLink',
                    type: NICmsContentField.EFieldType.text,
                    title: 'CTA Link',
                    default: ''
                },
                <NICmsContentField.IField>{
                    key: 'fontColor',
                    type: NICmsContentField.EFieldType.colorPicker,
                    colorPreview: true,
                    title: 'Font color'
                }
            ],
            canShow: data => data.footerItemsShowBVariant
        }
    ]
};
